export const devProjects = [
  {
    liveLink:
      "https://allocatr-neon.vercel.app/dashboard",
    github: "https://github.com/Kishore121523/Allocatr",
    heading: "Allocatr",
    desc: "AI-powered budget tracker with natural language expense entry and real-time analytics",
    category: "WebDev",
    image: "allocatr",
    externalLink: true,
  },
  {
    liveLink:
      "https://nestle-assistant-fnancbd7d7hzfxbm.canadacentral-01.azurewebsites.net/",
    github: "https://github.com/Kishore121523/nestle_bot",
    heading: "Nestle AI Chatbot",
    desc: "AI Chatbot with Hybrid RAG, Graph Reasoning, and Geolocation-based Product Search",
    category: "WebDev",
    image: "nestle",
    externalLink: true,
  },
  {
    liveLink: "https://wist-neon.vercel.app/dashboard",
    github: "https://github.com/Kishore121523/Wist",
    heading: "WIST",
    desc: "AI Enhanced Goal Planning System with Context Aware Suggestions",
    category: "WebDev",
    image: "wist",
    externalLink: true,
  },
  {
    liveLink: "https://vaultic.vercel.app/",
    github: "https://github.com/Kishore121523/Vaultic",
    heading: "Vaultic",
    desc: "A cloud storage solution for efficient file organization and secure sharing",
    category: "WebDev",
    image: "vaultic",
    externalLink: true,
  },
  {
    liveLink: "https://wealthsimple-coral.vercel.app/",
    github: "https://github.com/Kishore121523/WealthSimple",
    heading: "WealthSimple",
    desc: "Modern Banking and real-time Money Transfer Website",
    category: "WebDev",
    image: "wealthSimple",
    externalLink: true,
  },
  {
    liveLink:
      "https://chrome.google.com/webstore/detail/notezy/nlgngaailkikjkecgjogfdblapgalepl",
    github: "https://github.com/Kishore121523/Notezy",
    heading: "Notezy",
    desc: "CRUD Based Note Taking Extension with modern UI",
    category: "WebDev",
    image: "Notezy",
    externalLink: true,
  },
  {
    liveLink: "https://sastra.edu/ICWAGT2022/",
    github: "https://github.com/Kishore121523/MathConference",
    heading: "Math Conference",
    desc: "Developed website for International Math Conference",
    category: "WebDev",
    image: "MathConf",
    externalLink: true,
  },
];

// export const aiProjects = [
//   {
//     liveLink:
//       "https://nestle-assistant-fnancbd7d7hzfxbm.canadacentral-01.azurewebsites.net/",
//     github: "https://github.com/Kishore121523/nestle_bot",
//     heading: "Nestle AI Chatbot",
//     desc: "AI Chatbot with Hybrid RAG, Graph Reasoning, and Geolocation-based Product Search",
//     category: "Agentic RAG",
//     image: "nestle",
//     externalLink: true,
//   },
//   {
//     liveLink: "https://wist-neon.vercel.app/dashboard",
//     github: "https://github.com/Kishore121523/Wist",
//     heading: "WIST",
//     desc: "AI Enhanced Goal Planning System with Context Aware Suggestions",
//     category: "GenAI",
//     image: "wist",
//     externalLink: true,
//   },
// ];

export const combinedGraphicProjects = [
  {
    heading: "A Gentle Reminder.",
    desc: "Choose colors in accordance with the design's idea",
    category: "Graphic Design",
    image: "a_GD",
  },
  {
    heading: "Afghan? Half-gone?",
    desc: "Creativity and a Good Design always go hand in hand",
    category: "Graphic Design",
    image: "b_GD",
  },
  {
    heading: "Social-Me",
    desc: "Using typography and contrast to bring out the ideology behind",
    category: "Graphic Design",
    image: "e_GD",
  },
  {
    heading: "Diet, what?",
    desc: "Social Media Marketing for a startup.",
    category: "Marketing",
    image: "a_MR",
  },
  {
    heading: "We got your back!",
    desc: "Minimal yet Self Explanative design!",
    category: "Marketing",
    image: "b_MR",
  },
  {
    heading: "Festive Post!",
    desc: "A Ganesha designed using the company's logo.",
    category: "Marketing",
    image: "d_MR",
  },
];

export const skillsData = [
  {
    year: "2025",
    details: [
      {
        name: "Generative AI Engineer ",
        provider: "Wadhwani Foundation",
      },
      {
        name: "AI Developer (Freelance Contract)",
        provider: "AI RoundTable Inc.",
      },
      {
        name: "Gen AI Foundational Models for NLP & Language Understanding",
        provider: "IBM - Coursera",
      },
      {
        name: "Generative AI and LLMs: Architecture and Data Preparation",
        provider: "IBM - Coursera",
      },
      {
        name: "AWS Certified Cloud Practitioner CLF-C02",
        provider: "Udemy",
      },
    ],
  },
  {
    year: "2024",
    details: [
      {
        name: "React - The Complete Guide 2024 (incl. Next.js, Redux)",
        provider: "Udemy",
      },
      {
        name: "Masters in Computer Science",
        provider: "Lakehead University",
      },
      {
        name: "Google DevFest Hackathon - Runner Up",
        provider: "Google",
      },
    ],
  },
  {
    year: "2023",
    details: [
      {
        name: "Advanced Learning Algorithms",
        provider: "Stanford Online",
      },
      {
        name: "Bachelors in Computer Science",
        provider: "SASTRA University",
      },
      {
        name: "The Complete Node.js Developer Course (3rd Edition)",
        provider: "Udemy",
      },
      {
        name: "Supervised Machine Learning: Regression and Classification",
        provider: "Stanford Online",
      },
      {
        name: "Full-Stack Developer – AI & Cloud Geospatial Solutions ",
        provider: "Accenture",
      },
    ],
  },
  {
    year: "2022",
    details: [
      {
        name: "Machine Learning OnRamp",
        provider: "MathWorks",
      },
      {
        name: "Trinal Web Pvt Limited",
        provider: "Full-stack Developer - MERN Stack",
      },
    ],
  },
  {
    year: "2021",
    details: [
      {
        name: "Graduate Rotational Internship Program",
        provider: "Web Developer",
      },
      {
        name: "Graphic Designer",
        provider: "Frontend Developer",
      },
      {
        name: "Web Development Intern",
        provider: "Sparks Foundation",
      },
    ],
  },
  {
    year: "2020",
    details: [
      {
        name: "Adobe XD - UI/UX Designing",
        provider: "Udemy",
      },
      {
        name: "JavaScript-ES6, Advanced CSS",
        provider: "Udemy",
      },
      {
        name: "Bootstrap-4 with Projects",
        provider: "Udemy",
      },
    ],
  },
];
